import React from "react";
import Main from "./Main";
import { StateProvider } from "../../context/reducers/templatesContext";
import {
  initialState,
  reducer,
} from "../../context/reducers/templatesContext/reducer";

const TemplatesManagement = (props) => {
  return (
    <StateProvider initialState={initialState} reducer={reducer}>
      <Main {...props} />
    </StateProvider>
  );
};

export default TemplatesManagement;
